"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FullScreenDialog = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var styles_1 = require("./styles");
exports.FullScreenDialog = react_1.default.memo(function (_a) {
    var _b = _a.open, open = _b === void 0 ? true : _b, _c = _a.onClose, onClose = _c === void 0 ? function () { } : _c, children = _a.children, _d = _a.background, background = _d === void 0 ? 'paper' : _d, rest = __rest(_a, ["open", "onClose", "children", "background"]);
    var classes = (0, styles_1.useStyles)({ background: background });
    var handleClose = function (event, reason) {
        // recommended way to stop close on backdrop click which is what we need for fullscreen
        if (reason !== 'backdropClick')
            onClose();
    };
    // transition component
    var Transition = react_1.default.useMemo(function () {
        return react_1.default.forwardRef(function (props, ref) { return ((0, jsx_runtime_1.jsx)(core_1.Slide, __assign({ direction: "up", ref: ref }, props))); });
    }, []);
    return ((0, jsx_runtime_1.jsx)(core_1.Dialog, __assign({ open: open, onClose: handleClose, TransitionComponent: Transition, scroll: "paper", fullScreen: true, closeAfterTransition: true, disableEnforceFocus: true, classes: {
            paperScrollPaper: classes.content,
        } }, rest, { children: children })));
});
